<template>
	<div class="head-container ">
		<div class="header main-w">
			<div class="row cb">
				<div class="col">
					<p class="link" @click="$router.push('/')">健康科普研究中心</p>
					<p>Health Science Research Center</p>
				</div>
				<div class="row cc tel-box">
					<img src="@/assets/tel.png" class="tel" alt="联系电话" />
					<div class="col text-box">
						<span class="tel-text">010-85002999</span>
						<span class="mobile-text">176-1002-8051</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.head-container {
	background-color: #017575;
	margin-bottom: 16px;

	.header {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 40px;
		// background: url(../../assets/header.png) repeat-x center;
		// background-size: cover;
		height: 170px;
		color: #ffffff;
		p:nth-of-type(1) {
			font-size: 38px;
		}
		p:nth-of-type(2) {
			font-size: 19px;
			word-spacing: 1.5px;
		}
		.tel-box {
			.tel {
				width: 40px;
				height: 40px;
				margin-right: 14px;
			}
			.text-box {
				height: 44px;
				justify-content: space-between;
				.tel-text {
					color: #ffffff;
					font-size: 20px;
					line-height: 20px;
				}
				.mobile-text {
					color: #ffffff;
					font-size: 20px;
					line-height: 20px;
				}
			}
		}
	}
}
</style>
